module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-treatments",
    attrs: {
      "id": "top"
    }
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (!_vm.loading && _vm.props) ? _c('div', [_c('VueTrigger', {
    attrs: {
      "function1": _vm.navScrolled,
      "function2": _vm.notScrolled
    }
  }), _c('div', {
    staticClass: "pages-treatments__header"
  }), _c('HeaderSection', {
    staticClass: "pages-treatments__types",
    attrs: {
      "props": _vm.props.acf.header1
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(props) {
        return _c('div', {
          staticClass: "title"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "body",
      fn: function(props) {
        return _c('div', {
          staticClass: "body"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "button",
      fn: function(props) {
        return _c('div', {
          staticClass: "button"
        }, [_c('ScrollButton', {
          staticClass: "pages-treatments__smile-button",
          attrs: {
            "content": props.content,
            "scroll": {
              el: "#smilegallery",
              duration: 1250,
              easing: [0.445, 0.05, 0.55, 0.95],
              offset: -50,
              cancelable: true,
              x: false,
              y: true
            }
          }
        })], 1)
      }
    }], null, false, 671617851)
  }), _c('TabHeader', {
    attrs: {
      "props": _vm.props.acf.tabs
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _c('div', {
          staticClass: "tab"
        }, [_c('div', {
          staticClass: "tab--hero"
        }, [_c('ImgBox', {
          attrs: {
            "props": props.content.hero
          }
        }), _c('div', {
          staticClass: "textbox"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.hero_text
          }
        })], 1)], 1), _c('div', {
          staticClass: "tab--title1"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.title1
          }
        })], 1), _c('div', {
          staticClass: "tab--body1"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.body1
          }
        })], 1), _c('div', {
          staticClass: "tab--title2"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.title2
          }
        })], 1), _c('div', {
          staticClass: "tab--body2"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.body2
          }
        })], 1)])
      }
    }], null, false, 3999304696)
  }), _c('SmileGallery', {
    staticClass: "pages-treatments__gallery",
    attrs: {
      "id": "smilegallery",
      "props": _vm.props.acf.smilegallery
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6700f44b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/treatments/treatments.pug
// module id = 597
// module chunks = 1